import { render } from "./ProjectEdit.vue?vue&type=template&id=466e7fef&scoped=true&ts=true"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts"

import "./ProjectEdit.vue?vue&type=style&index=0&id=466e7fef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466e7fef"]])

export default __exports__